import { useState, useEffect, useRef, useContext } from "react";
import { classNames } from "primereact/utils";
import { Route, Routes, useLocation } from "react-router-dom";
import AppTopbar from "./layouts/AppTopbar";
import AppFooter from "./layouts/AppFooter";
import AppMenu from "./layouts/AppMenu";
import { Tooltip } from "primereact/tooltip";
import invoiceIcon from "./image/invoice6.png";
import subContractorIcon from "./image/sub.png";

import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "./App.scss";

import Profile from "./pages/Profile/Profile";
import Dashboard from "./pages/dashboard/Dashboard";
import ManageUsers from "./pages/users/ManageUsers";
import ManageClients from "./pages/clients/ManageClients";
import ClientDetail from "./pages/clients/ClientDetail";
import ViewEmployees from "./pages/employees/ViewEmployees";
import PayrollReports from "./pages/payrolls/PayrollReports";
import ChangePassword from "./pages/Profile/ChangePassword";
import EmployeeDetail from "./pages/employees/EmployeeDetail";
import AddWorkingHours from "./pages/payrolls/AddWorkingHours";
import PdaReport from "./pages/clients/PdaReport";
import ManageHolidays from "./pages/holidays/ManageHolidays";
import T4Payroll from "./pages/t4payroll/T4Payroll";
import PayCycle from "./pages/paycycle/PayCycle";
import AboutUs from "./pages/About/AboutUs";
import EmployerT4Payroll from "./pages/t4payroll/EmployerT4Payroll";
import T4Summary from "./pages/t4payroll/T4Summary";
import { T4ClientTab } from "./pages/clients/T4ClientTab";
import InvoiceDetailList from "./pages/invoice/InvoiceDetailList";
import AddInvoice from "./pages/invoice/AddInvoice";
import InvoicePayee from "./pages/invoice/InvoicePayee";
import SubContractorTab from "./pages/subContractor/SubContractorTab";
import SubContractor from "./pages/subContractor/SubContractor";
import SubContractorPayment from "./pages/subContractor/SubContractorPayment";
import AddSubContractorPayment from "./pages/subContractor/AddSubContractorPayment";
import UserInvoicePlatformCharge from "./pages/invoice-platform-charge/UserInvoice";
import AdminDashboard from "./pages/dashboard/AdminDashboard";
import UserDashboard from "./pages/dashboard/UserDashboard";
import ClientDashboard from "./pages/dashboard/ClientDashboard";
import EmployeeDashboard from "./pages/dashboard/EmployeeDashboard";
import AdminProfile from "./pages/Profile/AdminProfile";
import UserProfile from "./pages/Profile/UserProfile";
import ClientProfile from "./pages/Profile/ClientProfile";
import EmployeeProfile from "./pages/Profile/EmployeeProfile";
import UserDetailsDashboard from "./pages/users/UserDetailsDashboard";
import UnverifiedUsers from "./pages/users/UnverifiedUsers";
import NotFound from "./components/PageNotFound/PageNotFound";
import EditSubContractorPayment from "./pages/subContractor/EditSubContractorPayment";
import EditInvoice from "./pages/invoice/EditInvoice";

const App = () => {
  const [menuMode, setMenuMode] = useState("slim");
  const [overlayMenuActive, setOverlayMenuActive] = useState(false);
  const [sidebarStatic, setSidebarStatic] = useState(false);
  const [staticMenuDesktopInactive, setStaticMenuDesktopInactive] = useState(false);
  const [staticMenuMobileActive, setStaticMenuMobileActive] = useState(false);
  const [menuActive, setMenuActive] = useState(false);
  const [topbarMenuActive, setTopbarMenuActive] = useState(false);
  const [sidebarActive, setSidebarActive] = useState(false);
  const [pinActive, setPinActive] = useState(false);
  const [activeInlineProfile, setActiveInlineProfile] = useState(false);
  const [resetActiveIndex, setResetActiveIndex] = useState<boolean>(false);
  const copyTooltipRef = useRef<any>();
  const location = useLocation();

  const rawUserData = localStorage.getItem("user_data");
  let userData: any = null;
  userData = rawUserData ? JSON.parse(rawUserData) : null;

  const updateTime = 60000;
  let menuClick: any;
  let topbarItemClick: any;

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 991) {
        setMenuMode("sidebar");
      } else {
        setMenuMode("slim");
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getMenuItems = () => {
    if (!userData?.roles?.role_name) return [];
    switch (userData.roles.role_name) {
      case "Admin":
        return [
          { to: "/admin-dashboard", icon: "pi pi-home", label: "Dashboard" },
          { to: "/users", icon: "pi pi-users", label: "Users" },
          { to: "/clients", icon: "pi pi-user", label: "Clients" },
          { to: "/holidays", icon: "pi pi-calendar", label: "Holidays" },
          {
            to: "/unverified-users",
            icon: "pi pi-database",
            label: "Unverified User/Client",
          },
        ];
      case "User":
        return [
          { to: "/user-dashboard", icon: "pi pi-home", label: "Dashboard" },
          { to: "/clients", icon: "pi pi-users", label: "Clients" },
          { to: "/user-invoice", icon: "pi pi-file", label: "Charge Invoice" },
        ];
      case "Client":
        return [
          { to: "/client-dashboard", icon: "pi pi-home", label: "Dashboard" },
          {
            to: "/employees",
            icon: "pi pi-users",
            label: "Manage Employees",
          },
          { to: "/pay-cycle", icon: "pi pi-calendar", label: "Pay Cycle" },
          {
            to: `/report/run-payroll/${btoa(userData.pay_cycle_id)}/${btoa(userData.id)}`,
            icon: "pi pi-clock",
            label: "Run PayRoll",
          },
          { to: "/paystub", icon: "pi pi-book", label: "PayStub Reports" },
          { to: "/pd7a-report", icon: "pi pi-copy", label: "PD7A Reports" },
          {
            label: "Reports",
            icon: "pi pi-file",
            to: "/t4-reports",
          },
          {
            to: "/invoice-payee",
            icon: (
              // <img
              //   className="icon-invoice"
              //   src={invoiceIcon}
              //   alt="Invoice"
              //   style={{ width: "28px", height: "28px", filter: "invert(1)" }}
              // />

              <svg className="icon-invoice" width="24" height="24" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 2H18C19.1 2 20 2.9 20 4V20L16 18L13 20L10 18L7 20L4 18V4C4 2.9 4.9 2 6 2ZM12 6C10.34 6 9 7.34 9 9C9 10.66 10.34 12 12 12C12.83 12 13.5 12.67 13.5 13.5C13.5 14.33 12.83 15 12 15C11.17 15 10.5 14.33 10.5 13.5H9C9 15.16 10.34 16.5 12 16.5C13.66 16.5 15 15.16 15 13.5C15 11.84 13.66 10.5 12 10.5C11.17 10.5 10.5 9.83 10.5 9C10.5 8.17 11.17 7.5 12 7.5C12.83 7.5 13.5 8.17 13.5 9H15C15 7.34 13.66 6 12 6Z" />
              </svg>
            ),
            label: "Invoice",
          },
          {
            to: "/sub-contractor",
            icon: (
              <img
                src={subContractorIcon}
                className="icon-invoice"
                alt="sub contractor"
                style={{ width: "24px", height: "24px", filter: "invert(1)" }}
              />
            ),
            label: "Sub Contractor",
          },
        ];
      case "Employee":
        return [
          { to: "/employee-dashboard", icon: "pi pi-home", label: "Dashboard" },
          { to: "/paystub", icon: "pi pi-file", label: "My PayStub" },
          { to: "/t4reports", icon: "pi pi-file", label: "T4 Reports" },
        ];
      default:
        return [];
    }
  };

  useEffect(() => {
    copyTooltipRef.current?.updateTargetEvents();
  }, [location]);

  useEffect(() => {
    setResetActiveIndex(true);
    setMenuActive(false);
  }, [menuMode]);

  const onDocumentClick = () => {
    if (!topbarItemClick) setTopbarMenuActive(false);

    if (!menuClick) {
      if (isHorizontal() || isSlim()) {
        setMenuActive(false);
        setResetActiveIndex(true);
      }

      if (overlayMenuActive || staticMenuMobileActive) {
        setOverlayMenuActive(false);
        setStaticMenuMobileActive(false);
        unblockBodyScroll();
      }
    }

    topbarItemClick = false;
    menuClick = false;
  };

  const onMenuButtonClick = (event: any) => {
    menuClick = true;

    if (isOverlay()) {
      setOverlayMenuActive((prev) => {
        const newState = !prev;
        newState ? blockBodyScroll() : unblockBodyScroll();
        return newState;
      });
    }

    if (isDesktop()) {
      setStaticMenuDesktopInactive((prev) => !prev);
    } else {
      setStaticMenuMobileActive((prev) => {
        const newState = !prev;
        newState ? blockBodyScroll() : unblockBodyScroll();
        return newState;
      });
    }

    event.preventDefault();
  };

  const blockBodyScroll = () => {
    document.body.classList.add("blocked-scroll");
  };

  const unblockBodyScroll = () => {
    if (document.body.classList) {
      document.body.classList.remove("blocked-scroll");
    } else {
      document.body.className = document.body.className.replace(new RegExp("(^|\\b)" + "blocked-scroll".split(" ").join("|") + "(\\b|$)", "gi"), " ");
    }
  };

  const onTopbarItemClick = (event: any) => {
    topbarItemClick = true;
    setTopbarMenuActive((prev) => !prev);
    hideOverlayMenu();
    event.preventDefault();
  };

  const onToggleMenu = (event: any) => {
    menuClick = true;
    if (overlayMenuActive) setOverlayMenuActive(false);
    if (sidebarActive) setSidebarStatic((prev) => !prev);
    event.preventDefault();
  };

  const hideOverlayMenu = () => {
    setOverlayMenuActive(false);
    setStaticMenuMobileActive(false);
    unblockBodyScroll();
  };

  const onSidebarMouseOver = () => {
    if (menuMode === "sidebar" && !sidebarStatic) {
      setSidebarActive(isDesktop());
      setTimeout(() => setPinActive(isDesktop()), 200);
    }
  };

  const onSidebarMouseLeave = () => {
    if (menuMode === "sidebar" && !sidebarStatic) {
      setTimeout(() => {
        setSidebarActive(false);
        setPinActive(false);
      }, 250);
    }
  };

  const onMenuClick = () => {
    menuClick = true;
  };

  const onChangeActiveInlineMenu = (e: any) => {
    setActiveInlineProfile((prev) => !prev);
    e.preventDefault();
  };

  const onRootMenuItemClick = () => {
    setMenuActive((prev) => !prev);
  };

  const onMenuItemClick = (event: any) => {
    if (!event.item.items) {
      hideOverlayMenu();
      setResetActiveIndex(true);
    }

    if (!event.item.items && (isHorizontal() || isSlim())) {
      setMenuActive(false);
    }
  };

  const isHorizontal = () => menuMode === "horizontal";
  const isSlim = () => menuMode === "slim";
  const isOverlay = () => menuMode === "overlay";
  const isDesktop = () => window.innerWidth > 991;

  const layoutClassName = classNames("layout-wrapper", {
    "layout-static": menuMode === "static",
    "layout-overlay": menuMode === "overlay",
    "layout-overlay-active": overlayMenuActive,
    "layout-slim": menuMode === "slim",
    "layout-horizontal": menuMode === "horizontal",
    "layout-active": menuActive,
    "layout-mobile-active": staticMenuMobileActive,
    "layout-sidebar": menuMode === "sidebar",
    "layout-sidebar-static": menuMode === "sidebar" && sidebarStatic,
    "layout-static-inactive": staticMenuDesktopInactive && menuMode === "static",
  });

  return (
    <div className={layoutClassName} onClick={onDocumentClick}>
      <Tooltip ref={copyTooltipRef} target=".block-action-copy" position="bottom" content="Copied to clipboard" event="focus" />

      <AppTopbar
        items={getMenuItems()}
        updateTime={updateTime}
        menuMode={menuMode}
        topbarMenuActive={topbarMenuActive}
        activeInlineProfile={activeInlineProfile}
        onTopbarItemClick={onTopbarItemClick}
        onMenuButtonClick={onMenuButtonClick}
        onToggleMenu={onToggleMenu}
      />

      <AppMenu
        model={getMenuItems()}
        onRootMenuItemClick={onRootMenuItemClick}
        onMenuItemClick={onMenuItemClick}
        onToggleMenu={onToggleMenu}
        onMenuClick={onMenuClick}
        menuMode={menuMode}
        menuActive={menuActive}
        sidebarActive={sidebarActive}
        sidebarStatic={sidebarStatic}
        pinActive={pinActive}
        onSidebarMouseLeave={onSidebarMouseLeave}
        onSidebarMouseOver={onSidebarMouseOver}
        activeInlineProfile={activeInlineProfile}
        onChangeActiveInlineMenu={onChangeActiveInlineMenu}
        resetActiveIndex={resetActiveIndex}
      />

      <div className="layout-main">
        <div className="layout-main-content">
          <Routes>
            {/* profile route start */}
            <Route path="/profile" element={<Profile />} />
            <Route path="/admin-profile" element={<AdminProfile />} />
            <Route path="/user-profile" element={<UserProfile />} />
            <Route path="/client-profile" element={<ClientProfile />} />
            <Route path="/employee-profile" element={<EmployeeProfile />} />
            {/* profile route end */}
            {/* dashboard route start */}
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/admin-dashboard" element={<AdminDashboard />} />
            <Route path="/user-dashboard" element={<UserDashboard />} />
            <Route path="/client-dashboard" element={<ClientDashboard />} />
            <Route path="/employee-dashboard" element={<EmployeeDashboard />} />
            {/* dashboard route end */}
            {/* user route start */}
            <Route path="/users" element={<ManageUsers />} />
            <Route path="/user-details/:id" element={<UserDetailsDashboard />} />
            {/* un verified users */}
            <Route path="/unverified-users" element={<UnverifiedUsers />} />
            {/* user route end */}
            {/* client route start */}
            <Route path="/users/clients-list/:id" element={<ManageClients />} />
            <Route path="/clients" element={<ManageClients />} />
            <Route path="/clients/:id" element={<ClientDetail />} />
            <Route path="/pd7a-report" element={<PdaReport />} />
            <Route path="/pd7a-report/:id" element={<PdaReport />} />
            {/* client route end */}
            {/* employee route start */}
            <Route path="/employees" element={<ViewEmployees />} />
            <Route path="/employee/:id" element={<EmployeeDetail />} />
            {/* employee route end */}
            {/* report route start */}
            <Route path="/paystub" element={<PayrollReports />} /> <Route path="/paystub/:id" element={<PayrollReports />} />{" "}
            <Route path="/pay-cycle/working-hours/:payCycleId/:clientId" element={<AddWorkingHours />} />
            {/* report route end */}
            {/* run payroll route */}
            <Route path="/report/run-payroll/:payCycleId/:clientId" element={<AddWorkingHours />} />
            {/* pay-cycle route */}
            <Route path="/pay-cycle" element={<PayCycle />} />
            <Route path="/pay-cycle/:id" element={<PayCycle />} />
            {/* t4 report route start */}
            <Route path="/t4-reports" element={<T4ClientTab />} />
            <Route path="/t4reports" element={<T4Payroll />} />
            {/* <Route path="/employer-t4reports" element={<EmployerT4Payroll/>} />
            <Route path="/t4-summary" element={<T4Summary />} /> */}
            <Route path="/t4-reports/:id" element={<T4ClientTab />} />
            {/* <Route path="/employer-t4reports/:id" element={<EmployerT4Payroll/>} /> */}
            {/* <Route path="/t4-summary/:id" element={<T4Summary />} /> */}
            {/* t4 report route start */}
            {/* change password route start */}
            <Route path="/change-password" element={<ChangePassword />} />
            {/* change password route end */}
            {/* holidays route start */}
            <Route path="/holidays" element={<ManageHolidays />} />
            {/* holidays route end */}
            {/* Invoice Route */}
            <Route path="/invoice-list" element={<InvoiceDetailList />} />
            <Route path="/invoice-list/:id" element={<InvoiceDetailList />} />
            <Route path="/invoice" element={<AddInvoice />} />
            <Route path="/invoice/:payeeId" element={<AddInvoice />} />
            <Route path="/edit-invoice/:payeeId" element={<EditInvoice />} />
            <Route path="/invoice-payee" element={<InvoicePayee />} />
            <Route path="/invoice-payee/:id" element={<InvoicePayee />} />
            {/* sub contractor route start */}
            <Route path="/sub-contractor" element={<SubContractor />} />
            <Route path="/sub-contractor/:id" element={<SubContractor />} />
            <Route path="/sub-contractor-payment" element={<SubContractorPayment />} />
            <Route path="/sub-contractor-payment/:id" element={<SubContractorPayment />} />
            {/* sub contractor make payment */}
            <Route path="/payment/:payeeId" element={<AddSubContractorPayment />} />
            <Route path="/edit-sub-contractor/:payeeId" element={<EditSubContractorPayment />} />
            {/* sub contractor route End */}
            {/* user invoice platform chage */}
            <Route path="/user-invoice/:id" element={<UserInvoicePlatformCharge />} />
            {/* user invoice in user login */}
            <Route path="/user-invoice" element={<UserInvoicePlatformCharge />} />
            {/* <Route path="*" element={<Dashboard />} /> */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
        {/* show mask when mobile active sidebar */}
        {(staticMenuMobileActive || overlayMenuActive) && <div className="layout-mask" />}
        <AppFooter />
      </div>
    </div>
  );
};

export default App;
